// Thin page wrapper for /sinastria/criar, renders SynastryCreationForm.
import { useState } from 'react';
import { SynastryCreationForm } from '../components/synastry/SynastryCreationForm';

export function SynastryCreatePage() {
  const [pendingInviteLink, setPendingInviteLink] = useState('');

  return (
    <div className="min-h-screen bg-[#0D1130] py-12 px-4">
      {pendingInviteLink ? (
        <div className="max-w-md mx-auto text-center">
          <div className="text-[#C9A84C] text-3xl tracking-[8px] mb-6">✦</div>
          <h2 className="text-[#C9A84C] text-xl font-light mb-4">Link de convite gerado</h2>
          <p className="text-[#F5ECD7]/70 text-sm mb-6 leading-relaxed">
            Compartilhe o link abaixo com a pessoa que você quer incluir na sinastria.
          </p>
          <div className="flex gap-2 mb-4">
            <input
              readOnly
              value={pendingInviteLink}
              className="flex-1 bg-transparent border border-[#C9A84C]/30 text-[#F5ECD7]/80 text-xs p-3 rounded-sm"
            />
            <button
              onClick={() => navigator.clipboard.writeText(pendingInviteLink)}
              className="px-4 py-3 bg-[#C9A84C] text-[#0D1130] text-xs font-bold hover:bg-[#C9A84C]/90"
            >
              Copiar
            </button>
          </div>
          <p className="text-[#F5ECD7]/30 text-xs">
            A análise será gerada após a outra pessoa preencher os dados.
          </p>
        </div>
      ) : (
        <SynastryCreationForm onInviteCreated={setPendingInviteLink} />
      )}
    </div>
  );
}
